export default __webpack_public_path__ + "static/media/cotizacion.4b12ddd0.png";